import {useGrpcRequestMutation} from '@aboutyou/data-fetcher';
import {Session} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/session.types';
import {BasketPageService_ChangeQuantityLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/page/service.grpc.lazy';
import {useBasketToken, useFullSession} from '@aboutyou/user';
import {useCallback} from 'react';
import {useReductionsStateRequestParameter} from '../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useTargetGroupIdentifier} from '../../../shared-deprecated/useTargetGroupIdentifier';
import {useUpdateBasketSectionsCallback} from './useUpdateBasketSections';

export const useQuantityChangeHandler = (itemKey: string) => {
  const session = useFullSession() as Session;
  const targetGroupIdentifier = useTargetGroupIdentifier();

  const {token: minimalStateToken} = useBasketToken();

  const reductionsState = useReductionsStateRequestParameter();

  const updatePageBulkSections = useUpdateBasketSectionsCallback();

  const updateQuantityCallback = useGrpcRequestMutation(
    BasketPageService_ChangeQuantityLazy,
    {
      onSuccess: data => {
        updatePageBulkSections(data.sections);
      },
    },
  );

  return useCallback(
    async (quantity: number) => {
      return updateQuantityCallback.mutateAsync({
        session,
        quantity,
        itemKey,
        basketToken: minimalStateToken,
        targetGroup: targetGroupIdentifier,
        reductionsState,
      });
    },
    [updateQuantityCallback, itemKey, minimalStateToken],
  );
};
